import { Action, createReducer, on } from '@ngrx/store';
import { AssignToMeState } from './assign-to-me.types';
import {
  assignToMeAction,
  assignToMeFailureAction,
  assignToMeSuccessAction
} from './assign-to-me.actions';

const initialState = {
  updating: false,
  updated: false,
  data: null,
  error: null,
};

const assignToMeReducer = createReducer<AssignToMeState>(
  initialState,
  on(
    assignToMeAction,
    state => ({
      ...state,
      updating: true,
      updated: false,
    })
  ),
  on(
    assignToMeSuccessAction,
    (state, action) => ({
      ...state,
      updating: false,
      updated: true,
      data: action.data,
      error: null,
    })
  ),
  on(
    assignToMeFailureAction,
    (state, action) => ({
      ...state,
      updating: false,
      updated: false,
      error: action.error,
    })
  ),
);

export const reducer = (state: AssignToMeState, action: Action) => assignToMeReducer(state, action);
